<div style="background-color: #f5f5f5; height: 4000px; width: 100%; position: fixed; z-index: -999"></div>
    <div class="d-flex flex-column col-md-6 mx-auto bg-white">
        <div class="overflow-auto vh-100">
            <app-navbar class="col-md-6" style="position:static; z-index: 99999"></app-navbar>
            <router-outlet></router-outlet>
            <app-footer></app-footer>
        </div>
    </div>
